import { Copy, Check } from 'lucide-react'
import { useState } from 'react'
import InfoNote from '@/domains/mobile-web/components/InfoNote/InfoNote'
import Button from '@/shared/components/ui/Button'
import { cn } from '@/lib/utils'

interface CardTautanProps {
    linkAffiliate?: string
    /** Shown in place of a missing link */
    placeholder?: string
    note?: string
}

const copyToClipboard = async (value: string) => {
    try {
        await navigator.clipboard?.writeText(value)
    } catch {

    }
}

const CardTautan = ({ linkAffiliate, placeholder = '-', note }: CardTautanProps) => {
    const [isCopied, setIsCopied] = useState(false)

    const handleCopy = () => {
        if (!linkAffiliate) return
        copyToClipboard(linkAffiliate)
        setIsCopied(true)
        window.setTimeout(() => setIsCopied(false), 1500)
    }

    return (
        <div className='shadowCard p-3 gap-3 flex flex-col w-full'>
            <p className='title2medium'>Bagikan Tautan Afiliate</p>
            <div className="w-full flex items-center gap-3 justify-between rounded-[4px] border border-blue-cs-200 px-4 py-2 bg-bg-grey-100">
                <span className={cn('body1 truncate shrink flex-1', !linkAffiliate && 'text-text-grey')}>
                    {linkAffiliate || placeholder}
                </span>
                <Button
                    onClick={handleCopy}
                    type='button'
                    disabled={!linkAffiliate}
                    className='btn-fill-blue shrink-0'
                >
                    {isCopied ? (
                        <>
                            <Check className="w-4 h-4" />
                            <span>Tercopy!</span>
                        </>
                    ) : (
                        <>
                            <Copy className="w-4 h-4" />
                            <span>Salin</span>
                        </>
                    )}
                </Button>
            </div>
            {note && <InfoNote>{note}</InfoNote>}
        </div>
    )
}

export default CardTautan
